import rodis from "./rodilleras.js";
import cintos from "./cinturones.js";
import calz from "./calzado.js";
import muñequeras from "./muñequeras.js";
import rodillerasRig from "./rodilleras-rig.js";
import sing from "./singlets.js";
import vendas from "./vendas.js";

const allProducts = [
  ...rodis,
  ...cintos,
  ...calz,
  ...muñequeras,
  ...rodillerasRig,
  ...sing,
  ...vendas

];

export default allProducts;